import React from 'react';
import { PropTypes } from 'prop-types';
import { withStyles } from '@mui/styles';
//import { Icon, Typography, Tooltip } from '@mui/material/Grid';
import Chatbot from 'react-chatbot-kit-extension';
import config from './config.js';
import MessageParser from './MessageParser.js';
import ActionProvider from './ActionProvider.js';
import ChatbotHeader from './ChatbotHeader';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import MicIcon from '@mui/icons-material/Mic';
import {Button, Icon, Typography} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { connect } from 'react-redux';
import AudioConversation from './AudioConversation.js';
import { withRouter } from 'utils';
import { setChatbotState } from '../../store/actions/appActions';
import { createChatBotMessage } from 'react-chatbot-kit-extension';
import BotText from './BotText';


const styles = (theme) => ({
  container: {
    width: '95%',
    margin: '0 auto',
  },

  footer: {
    width: '100%',
    textAlign: 'right',
  },
  footerFont: {
    [theme.breakpoints.down('md')]: {
      fontSize: 8,
    },
  },
  footerFontTransparent: {
    color: 'transparent',
    paddingLeft: '400px',
  }

});

class DocChatBot extends React.Component {

 constructor(props) {
    super(props); 
    
    let defValue = sessionStorage.getItem('system_prompt');

    this.state = {
      showChat: false,
      expanded: true,
      dialogOpen: false,
      user: props.user || null, // Use a default user ID if not provided
      defPrompt: defValue ? defValue : '', // Default system prompt
      messages: null,
      selectedClient: props.selectedClient || null, // Use a default client ID if not provided
      defPrompt: defValue ? defValue : '', // Default system prompt
      messageid: 0,
      movedToBottom: false,
      minimized: false
    };
  }

  //toggleMinimize = () => this.setState((s) => ({ minimized: !s.minimized }));
  //setHidden = (v) => this.setState({ hidden: v });

  toggleMinimize = () => {
    this.setState(
      (s) => ({ minimized : !s.minimized }),   // only one flag
      () => this.props.onMinimizeChange?.(this.state.minimized)
    );

    window.dispatchEvent(new Event('chat-closed'));
  };

  
  addEnterKeyListener = () => {
    const input = document.querySelector('.react-chatbot-kit-chat-input');
    if (input && !input._enterListenerAdded) {
      input.addEventListener('keydown', (e) => {
         if (e.key === 'Enter' && !e.shiftKey && !e.ctrlKey && !e.altKey) {
          e.preventDefault();
          this.handleSendClick();
        }
      });
      input._enterListenerAdded = true;
    }
  }

  handleSendClick = () => {
    // Find the input field rendered by react-chatbot-kit
    const btn = document.querySelector(
      '.react-chatbot-kit-chat-btn-send' // (for v2.x, this may be 'input' or '.MuiInputBase-input')
    );
    
    const input = document.querySelector('.react-chatbot-kit-chat-input');

    if (input.value.trim() === '') {
      // If the input is empty, do nothing
      return;
    }

    btn.click();
    // Or, if you want to use the chatbotRef:
    // chatbotRef.current.handleSend();
  
    // Only move the input ONCE
    if (!this.state.movedToBottom) {
      this.setState({ movedToBottom: true });
      const inputContainer = document.querySelector('.react-chatbot-kit-chat-input-container');
      const msgContainer = document.querySelector('.react-chatbot-kit-chat-message-container');
      const btnContainer = document.querySelector('.chatbot-send-button');
      //const micContainer = document.querySelector('.chatbot-mic-button');

      if (inputContainer) {
        inputContainer.classList.add('moved-to-bottom');
        msgContainer.classList.add('moved-to-bottom');
        btnContainer.classList.add('moved-to-bottom');
        //micContainer.classList.add('moved-to-bottom');

        btnContainer.style.removeProperty('top');  
        btnContainer.style.removeProperty('left'); 

      }

      document.querySelector('.chatbot-wrapper').style.height = '80%';
      document.querySelector('.react-chatbot-kit-chat-container').style.height = '80%'; 
    }
  };

  handleTranscriptEvent = (e) => {
    const { role, text } = e.detail || {};
    if (!text || !text.trim()) return;

    /* always read the freshest array directly from the store,
      not from React props that might be one render behind      */
    const { dispatch, chatbotState } = this.props;
    const oldMessages = (chatbotState.messages || []).slice();   // clone

    /* turn the transcript into the SAME object type the UI uses */
    let nextMessages;
    if (role === 'user') {
      nextMessages = [...oldMessages, { role: 'user', content: text }];
    } else {                             // assistant
      const botMsg = createChatBotMessage(text, { loading:false });
      nextMessages = [...oldMessages, botMsg];
    }

    dispatch(
      setChatbotState({
        ...chatbotState,
        messages: nextMessages                 // history grows – never shrinks
      })
    );
  };

  // This will turn on/off the microphone
  handleMicClick = () => {

    // 1. "Turn on" the microphone (simulate click or whatever integration you have):
  //   const micButton = document.querySelector('.react-chatbot-kit-mic-icon');
   // if (micButton) {
     // micButton.click();
    //}

    // Get the SpeechRecognition object from the window (with webkit fallback)
      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      
      if (!SpeechRecognition) {
        throw new Error('Speech recognition is not supported by this browser.');
      }

      const recognition = new SpeechRecognition();
      recognition.lang = 'en-US';
      recognition.interimResults = false;
      recognition.maxAlternatives = 1;

      recognition.start();
      

      recognition.onresult = (event) => {
        const speechResult = event.results[0][0].transcript;
        input.value = speechResult; // Set the input field's value to the recognized speech.
        console.log('Speech recognized:', speechResult);
      }

     // 2. Set focus to the input/textarea field:
    // react-chatbot-kit uses textarea
    const input = document.querySelector('.react-chatbot-kit-chat-input');
    if (input) {
      input.focus();
    }


  };

  removePlaceholder = () => {
    // Selects textarea or input; adjust selector as needed for your chatbot version
    const input = document.querySelector('.react-chatbot-kit-chat-input');
    if (input && input.placeholder !== '') {
      input.placeholder = '';
    }
  }

  handleResize = () => {

      //let outerContainer = document.querySelector('.chatbot-wrapper');  
      let msgContainer = document.querySelector('.react-chatbot-kit-chat-message-container');
      //let btnContainer = document.querySelector('.chatbot-send-button');
      //let micContainer = document.querySelector('.chatbot-mic-button');
      
      if (msgContainer) {
        //this.toggleChatSize();
        const messages = (this.props.chatbotState && this.props.chatbotState.messages) || [];
        if (!this.state.movedToBottom && messages.length > 0 ) {
          
          let obj = document.querySelector('.react-chatbot-kit-chat-container')

          if (obj) {
            obj.style.height = '80%';
            obj.style.width = '30%';
          }
                    
          document.querySelector('.react-chatbot-kit-chat-input').placeholder = '';

          // if not moved to bottom but messages exit
          // should only happen if messages exist
          const inputContainer = document.querySelector('.react-chatbot-kit-chat-input-container');
          //const msgContainer = document.querySelector('.react-chatbot-kit-chat-message-container');
          const btnContainer = document.querySelector('.chatbot-send-button');
          //const micContainer = document.querySelector('.chatbot-mic-button');
    
          if (inputContainer) {
            this.setState({ movedToBottom: true });

            if (inputContainer) {
              inputContainer.classList.add('moved-to-bottom');
              msgContainer.classList.add('moved-to-bottom');
              btnContainer.classList.add('moved-to-bottom');
              //micContainer.classList.add('moved-to-bottom');

              btnContainer.style.removeProperty('top');  
              btnContainer.style.removeProperty('left'); 
  
            }
  


            document.querySelector('.chatbot-wrapper').style.height = '80%';
            document.querySelector('.react-chatbot-kit-chat-container').style.height = '80%'; 
          }
        } else {
          //btnContainer.style.top = `${outerContainer.offsetHeight - outerContainer.offsetTop - (window.screen.height/50)}px`;    
        //micContainer.style.top = `${outerContainer.offsetHeight - outerContainer.offsetTop + 60}px`;    
        }
      
        document.querySelector('.react-chatbot-kit-chat-input').focus();
      
        //btnContainer.style.right = '40px';

        if (!this.state.movedToBottom) {   // first-message not sent yet
          const inputBox = document.querySelector('.react-chatbot-kit-chat-input-container');
          if (inputBox) {
            //btnContainer.style.top =
              //`${inputBox.offsetTop
                //+ inputBox.offsetHeight
                //- btnContainer.offsetHeight
                //- 10}px`;      // same “bottom:10px” as in CSS
          }
        }

      }
    
   if (!this.state.movedToBottom){     // only while in “greeting” mode
      this.placeArrow();
    }


  }

  componentDidUpdate(prevProps, prevState) {

    // Detect when chat just became visible
    if (!prevState.showChat && this.state.showChat) {
      this.handleResize();
     // setTimeout(() => this.addEnterKeyListener(), 0);
    }
    this.addEnterKeyListener();
    this.removePlaceholder();

    if (!this.state.movedToBottom){     // only while in “greeting” mode
      this.placeArrow();
    }
  }

  componentDidMount() {   
    const { chatbotState } = this.props; 

    this.props.provideApi?.(this);

    //this.setHidden(false);  
    //this.props.setOpenChat?.(() => this.setHidden(false)); 
    window.addEventListener('close-chat', this.props.toggleChat);
    
    this.setState({
      messages: chatbotState.messages || [],
      messageid: chatbotState.messageid || null,
      selectedClient: chatbotState.selectedClient || this.state.selectedClient,
    });


    window.addEventListener('resize', this.handleResize);
    // Optionally: call once to get initial size
    setTimeout(() => this.addEnterKeyListener(), 0);
    this.handleResize(false);

     this.placeArrow(); 

     console.log('router prop →', this.props.router);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('close-chat', this.props.toggleChat);
     this.props.provideApi?.(null);
  }

  handleClickOpen = () => {
    this.setState({'dialogOpen': true});
  };

  handleClose = () => {
    this.setState({'dialogOpen': false});
  };

  handleSave = () => {
    sessionStorage.setItem('system_prompt', this.state.defPrompt);
    this.setState({'dialogOpen': false});
  };

  // Return distance from `el` to `stopAt` (exclusive)
  offsetTopUntil = (el, stopAt) => {
    let top = 0;
    while (el && el !== stopAt) {
      top += el.offsetTop;
      el   = el.offsetParent;
    }
    return top;
  };
  
  placeArrow = () => {
    const arrow = document.querySelector('.chatbot-send-button');
    const box   = document.querySelector('.react-chatbot-kit-chat-input-container');
    const wrap  = document.querySelector('.chatbot-wrapper');
    if (!arrow || !box || !wrap) return;

    /* once the chat switches to “conversation” mode, the CSS
      .moved-to-bottom class takes care of positioning           */
    if (this.state.movedToBottom) return;

    /* viewport-relative rectangles */
    const boxRect  = box .getBoundingClientRect();
    const wrapRect = wrap.getBoundingClientRect();

    /* 1 – vertical: align arrow 10 px up from the bar’s bottom */
    const topInsideWrapper =
          boxRect.bottom - wrapRect.top - arrow.offsetHeight - 10;
    arrow.style.top = `${topInsideWrapper}px`;

    /* 2 – horizontal: 12 px in from the bar’s right edge        */
    //const leftInsideWrapper =
      ///    boxRect.right  - wrapRect.left - arrow.offsetWidth - 12;
    //arrow.style.left = `${leftInsideWrapper}px`;

    /* 3 – show it now that it’s in the correct place            */
    arrow.style.visibility = 'visible';
  };

  onAudioConversation = async (shouldBeOn) => {
    try {
      console.log('Audio conversation started');
      const audioConversation = AudioConversation.getInstance();
      const isOn = audioConversation.isConversationStarted();
      if (shouldBeOn && !isOn) {
        audioConversation.startConversation(
          this.props.router, 
          this.props.user, 
          this.props.selectedClient, 
          this.props.dispatch, 
          this.props.chatbotState || { messages: [] },
          () => ({ app: this.props.app })
        );
        this.toggleMinimize();
      } else if (!shouldBeOn && isOn) {
         await audioConversation.endConversation();
      } else {
        audioConversation.endConversation();

        if (this.state.minimized) {     // restore when finished
          this.toggleMinimize();
        }
      }

    } catch (error) {
      console.log(error);
      window.alert('Audio conversation failed to start. Please check your microphone permissions and try again.');
    }
  }

  render() {
    
    const { chatbotMessages } = this.props; // from Redux!

    const chatbotConfig = {
      ...config,                           // base configuration
      user          : this.props.user,
      selectedClient: this.state.selectedClient,

      /* keep every component INSIDE config.customComponents */
      customComponents : {
        ...config.customComponents,  
        botChatMessage : (p) => <BotText {...p} />,      // ← HTML renderer
        header     : (p) => (
          <ChatbotHeader
            {...p}
            onClose ={this.toggleMinimize}
            onExpand={this.props.toggleChatSize}
            onAudioConversation={this.onAudioConversation}
            onShowMicDialog={this.props.onShowMicDialog}
            keyboardOnly={this.props.keyboardOnly}  
            audioActive={this.props.audioActive}
            micSpeaking={this.props.micSpeaking}
            micListening={this.props.micListening}
            micThinking={this.props.micThinking}
          />
        ),
      },
    };


    const history =
            Array.isArray(chatbotMessages) && chatbotMessages.length === 0
              ? undefined           // let the library render initialMessages
              : chatbotMessages;    // otherwise use the persisted history

    const hasUserMsgs =
      Array.isArray(chatbotMessages) && chatbotMessages.length > 0;

    return (
      <div
        className={`chatbot-wrapper ${this.state.minimized
          ? 'chatbot-hidden'
          : ''}`}
      >        
      {false && this.state.minimized && (
              <Icon
            sx={{ color:'#00A887', fontSize:32, lineHeight:'52px',
                  textAlign:'center', width:'100%' }}
        >
            support_agent
        </Icon>
      )}


      { console.log('%cChatbot props',
        'color:#07c;font-weight:bold',
        { history: chatbotMessages, custom: config.customComponents }
      )}

      

      <Chatbot
          messageHistory={history}
          config={chatbotConfig}
          messageParser   ={MessageParser}
          actionProvider  ={ActionProvider}
          placeholderText =''
      />

          <div
            className='chatbot-mic-button'
            onClick={this.handleMicClick}
            style={{
              position: 'absolute',
              right: '45px',
              color: 'gray',
              zIndex: 999,
              cursor: 'pointer'
            }}
          >
            <MicIcon id='miccon' fontSize='medium' />
          </div>
          <div
            className='chatbot-send-button'
            onClick={this.handleSendClick}
            style={{
              position: 'absolute',
            }}
          >
              <ArrowCircleUpIcon id='arrowIcon' fontSize='medium' />
          </div>


          <Dialog
            open={this.state.dialogOpen}
            fullWidth={true}
            maxWidth={'xl'}
            style={{

              zIndex: 9999

            }}
          >
          <DialogTitle>System Prompt</DialogTitle>
           <DialogContent>
          <DialogContentText>
            Below is the system prompt.  Any updates will just be for this session for the purpose of testing.
          </DialogContentText>
         <textarea
          name='postContent'
          value={this.state.defPrompt}
          onChange={(e) => this.setState({ defPrompt: e.target.value })}
          rows={25}
          cols={135}
        />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleClose}>Cancel</Button>
          <Button onClick={this.handleSave}>Save</Button>
        </DialogActions>
          </Dialog>

          {!hasUserMsgs && (
             <Typography className='chatbot-reset-hint'>
                Type or say &quot;Clear&nbsp;chat&quot; at any time to reset
            </Typography>
          )}
          {hasUserMsgs && (                                /* after first msg  */
            <Typography className='chatbot-reset-hint-small'>
              AI can make mistakes. Check and review the data and info.
            </Typography>
          )}
        </div>



    )  
  }
}

DocChatBot.propTypes = {
  classes: PropTypes.object,
  toggleChat: PropTypes.func.isRequired,
  //minimize: PropTypes.func.isRequired,
  onMinimizeChange: PropTypes.func,
  setOpenChat: PropTypes.func.isRequired,
  toggleChatSize: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  selectedClient: PropTypes.number.isRequired,
  prevstate: PropTypes.object,
  router: PropTypes.object,
  chatbotState: PropTypes.object.isRequired,
  chatbotMessages: PropTypes.array.isRequired,
  chatbotMessageId: PropTypes.number,
  dispatch: PropTypes.func.isRequired,
  provideApi : PropTypes.func,
  onShowMicDialog    : PropTypes.func,            // show “Microphone Access” dialog
  onKeyboardOnly     : PropTypes.func,              // optional: force keyboard flow  
  keyboardOnly      : PropTypes.bool,                // optional: disable mic button
  audioActive       : PropTypes.bool,              // is audio currently active
  micSpeaking       : PropTypes.bool,              // is the user currently speaking
  micListening       : PropTypes.bool,              // is the mic currently listening
  micThinking       : PropTypes.bool,              // is the assistant processing a turn
};

const mapStateToProps = (state) => ({
  chatbotState: state.app.chatbot || {},
  chatbotMessages: state.app.chatbot.messages,
  chatbotMessageId: state.app.chatbot.messageid
});
/*
const styled = withStyles(styles)(DocChatBot);

const connected = connect(
  mapStateToProps,
  null,
  null,
  { forwardRef: true }          
)(styled);

const routed = withRouter(connected);   // last HOC in the chain

export { routed as DocChatBot };     // named export  (old style)
export default routed;                  // default export (for new code)
*/

//* 1 – styles */
const Styled = withStyles(styles)(DocChatBot);

/* 2 – redux (with ref-forwarding) */
const Connected = connect(
  mapStateToProps,
  null,
  null,
  { forwardRef: true }            // still required
)(Styled);

/* 3 – explicit forwardRef wrapper */
const ConnectedWithRef = React.forwardRef((props, ref) => (
  <Connected {...props} ref={ref} />
));
ConnectedWithRef.displayName = 'DocChatBot';

/* 4 – router LAST and SINGLE export */
const Wrapped = withRouter(ConnectedWithRef);       // has router + ref
export default Wrapped;                             // default
export { Wrapped as DocChatBot };                   // named (same object)